// app/frontend/controllers/notifications_controller.js
// Handles real-time notifications via ActionCable
// Displays toast notifications when events are received from the server

import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
    static targets = ["container"]

    connect() {
        this.consumer = createConsumer()
        this.subscription = this.consumer.subscriptions.create("NotificationsChannel", {
            received: (data) => this.handleNotification(data)
        })
    }

    disconnect() {
        if (this.subscription) {
            this.subscription.unsubscribe()
        }
        if (this.consumer) {
            this.consumer.disconnect()
        }
    }

    /**
     * Handle incoming notification from ActionCable
     * @param {Object} data - Notification payload
     * @param {string} data.type - Notification type (e.g., "trip_completed")
     * @param {string} data.title - Toast title
     * @param {string} data.message - Toast message
     * @param {Object} data.data - Additional data
     */
    handleNotification(data) {
        console.log("[Notifications] Received:", data)
        this.showToast(data.type, data.title, data.message)
    }

    /**
     * Display a toast notification
     * @param {string} type - Notification type for styling
     * @param {string} title - Toast title
     * @param {string} message - Toast message
     */
    showToast(type, title, message) {
        const container = this.containerTarget

        const toast = document.createElement("div")
        toast.className = `k-toast k-toast-${type === "trip_completed" ? "success" : "info"}`
        toast.innerHTML = `
      <div class="k-toast-content">
        <strong>${this.escapeHtml(title)}</strong>
        <p>${this.escapeHtml(message)}</p>
      </div>
      <button type="button" class="k-toast-close" onclick="this.parentElement.remove()">
        <wa-icon name="x"></wa-icon>
      </button>
    `

        container.appendChild(toast)

        // Auto-remove after 5 seconds
        setTimeout(() => {
            toast.classList.add("k-toast-exit")
            setTimeout(() => toast.remove(), 300)
        }, 5000)
    }

    /**
     * Escape HTML to prevent XSS
     * @param {string} text - Text to escape
     * @returns {string} Escaped text
     */
    escapeHtml(text) {
        const div = document.createElement("div")
        div.textContent = text
        return div.innerHTML
    }
}
